/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jan 12 2024
 **/

import { useEffect } from "react";
import { Configure } from "@/frameworks/libraries/utilities";
import { usePersistActions, usePersistStore } from "@/frameworks/core/persistence";

/**
 * Fetches and persists user information based on the provided user identifier.
 *
 * @param {string} id - The identifier of the user, typically "me" to refer to the currently authenticated user.
 * @return {WebServices.User.UserInfo} The user information object.
 */
export function usePersistUser(id: "me"): WebServices.User.UserInfo;
export function usePersistUser(id: string): WebServices.User.UserInfo | undefined;
export function usePersistUser(id: "me" | string) {
	const _id = id === "me" ? Configure.userID : id;
	const user = usePersistStore((state) => state.users[_id]);
	const { users } = usePersistActions();
	useEffect(() => {
		// If user information is missing or expired, fetch it again
		users.get_user(_id);
	}, [user]);
	return user as WebServices.User.UserInfo | undefined;
}
export default usePersistUser;
